import { useNavigate } from 'react-router-dom'
import { FormItemContainer } from '@/components'
import { Form, Input, Button, Typography, Image, Checkbox } from 'antd'
import {
  UserOutlined,
  LockOutlined,
  MailOutlined,
  SafetyCertificateOutlined,
} from '@ant-design/icons'
import { CommonProps } from './index'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { addToken, setPrivatize, setUserInfo, updateRole } from '@/redux/userSlice'
import {
  useLogin,
  useVerify,
  useGetMenuList,
  useAgreement,
  useUserInfo,
  useEmailVerify,
} from './util'
import Protocol from './protocol'
import { useEffect, useState } from 'react'
import FormItem from 'antd/es/form/FormItem'
import { Message } from '@/components/message'
import { t } from '@/i18n'

const { useForm } = Form

interface DirectLoginProps extends CommonProps {}

export const DirectLogin = (props: DirectLoginProps) => {
  const { setLoginStatus, loginType } = props
  const dispatch = useDispatch()
  //首次登陆
  const [firstLoginStatus, setFirstLoginStatus] = useState(false)
  const [form] = useForm()
  const navigate = useNavigate()
  const [visible, setVisible] = useState({ visibleShow: false, data: null })
  const [protocolTab, setProtocolTab] = useState<'privacy' | 'service'>(null)
  let [base, setBase] = useState({ base64: '', verify_token: '' })
  const [agreementOff, setAgreementOff] = useState(false)
  const [loginLoading, setLoginLoading] = useState(false)
  const [showCode, setShowCode] = useState(false)
  const [isCounting, setIsCounting] = useState(false)
  const [countdown, setCountdown] = useState(60)
  let [datas, setDatas] = useState<any>()
  let [enter, setEnter] = useState(true)
  let [showEmail, setShowEmail] = useState(false)
  const [loginSuccess, setLoginSuccess] = useState(false)
  let [protocol, setProtocol] = useState(false)
  const [pwdExpired, setPwdExpired] = useState(false)

  const [getMenuList, menuList] = useGetMenuList()
  const [login] = useLogin()
  const [verify] = useVerify()
  const [emailVerify] = useEmailVerify()
  const [agreement] = useAgreement()
  const [userInfo, getUserInfo, infoLoading] = useUserInfo()

  const consent = consented => {
    if (consented) {
      dispatch(addToken(JSON.stringify({ id: datas.ID, token: datas.token, loginType })))
      return
    }
    setVisible({ visibleShow: false, data: null })
    setDatas((datas = null))
  }

  const loginHandler = async (values: any) => {
    console.log('values-------------------', values)
    try {
      const { username, password, verify, agree, emailCode } = values
      if (!agree && agreementOff) {
        setProtocol(true)
        setTimeout(() => {
          setProtocol((protocol = false))
        }, 800)
        return
      }
      setLoginLoading(true)
      console.log('pass', `${username.replace(/\s*/g, '')} ${password}`)
      const { data } = await login({
        username: username.replace(/\s*/g, ''),
        password: `${username.replace(/\s*/g, '')} ${password}`,
        verify_token: base?.verify_token,
        verify: verify,
        email_verify: emailCode,
      })
      setCountdown(0)
      console.log('data, login response', data)

      if (data.code !== 200) {
        if (data.msg === '用户名不存在或密码错误') {
          Message.error(data.msg)
          return setLoginLoading(false)
        } else {
          Message.error(data.msg)
        }
      }
      // 是否第一次登录 1:是，2否
      if (data?.user_info.first_login === 1 && data?.code === 200) {
        localStorage.setItem('login-id', data?.user_info.ID)
        localStorage.setItem(
          'token',
          JSON.stringify({
            id: data?.user_info.ID ? data.user_info.ID : data.user_info.id,
            token: data.user_info.token,
          }),
        )
        setLoginLoading(false)
        return setFirstLoginStatus(true)
      }
      document.cookie = `${'protocol'}; max-age=${30 * 24 * 60 * 60}`
      setEnter(false)

      // 邮箱验证
      if (data?.email_auth_status === 'EmailAuthStatusEnable') {
        setShowEmail(true)
        setLoginLoading(false)
      }
      // 密码过期
      if (data?.user_info.pwd_expired === -2) {
        setPwdExpired(true)
      } else {
        setLoginLoading(false)
        setPwdExpired(false)
      }
      // 显示验证码
      if (
        data?.err_count >= data?.max_failed_verification_attempts ||
        data?.verification_status === 'VerificationStatusAlwaysEnable'
      ) {
        verification()
        setShowCode(true)
      }
      let tkn = JSON.stringify({
        id: data?.user_info.ID,
        token: data?.user_info?.token,
      })
      localStorage.setItem('token', tkn)

      // 登录状态
      if (data.code === 200) {
        setLoginSuccess(true)
      } else {
        setLoginSuccess(false)
        setLoginLoading(false)
        return
      }

      await getUserInfo()
        .catch(() => {})
        .then((response: any) => {
          localStorage.setItem(
            'info',
            unescape(window.atob(window.btoa(escape(JSON.stringify(response?.data))))) ==
              'undefined'
              ? window.btoa(escape(JSON.stringify({})))
              : window.btoa(escape(JSON.stringify(response?.data))),
          )
          dispatch(setUserInfo(response?.data))
          dispatch(
            updateRole(
              response?.data?.email
                ? '主账号'
                : response?.data?.user_data?.role?.role_header.role_name,
            ),
          )
          console.log('response11', response)
        })

      await getMenuList()
        .then(ref => {
          localStorage.setItem('account_type', ref?.data?.account_type)
          dispatch(setPrivatize(ref?.data?.privatize))
          // 添加token
          if (data.code == 200) {
            dispatch(
              addToken(
                JSON.stringify({ id: data.user_info.ID, token: data.user_info.token, loginType }),
              ),
            )
            setEnter(true)
            return
          }

          if (ref?.data?.account_type === 1 || ref?.data?.account_type === 3) {
            //1 bas 2觅影 3都有
            setLoginLoading(false)
            if (data.code === 200 && process.env.NODE_ENV !== 'dev') {
              navigate('/overview/dashboard')
            }
          } else if (ref?.data?.account_type === 2) {
            setLoginLoading(false)
            if (data.code === 200 && process.env.NODE_ENV !== 'dev') {
              // navigate('/easm/overview')
              const port = location.port ? `:${location.port}` : ''
              window.location.href = `${location.protocol}//${location.hostname}${port}/easm/overview`
            }
          } else {
            console.log('--------------------')
            setLoginLoading(false)
            if (data.code === 200 && process.env.NODE_ENV !== 'dev') {
              navigate('/easm/overview')
            }
          }
        })
        .catch(err => {
          console.log('Menu list error: ', err)
        })

      setDatas(data?.user_info)

      agreement({ token: data.user_info.token, user_id: data.user_info.ID })
        .then(res => {
          console.log('res', res)

          if (res.data?.on_off === 1) {
            setVisible(
              (visible = {
                visibleShow: true,
                data: data,
              }),
            )
            return
          }
        })
        .catch(err => {})
    } catch (error: any) {
      setLoginLoading(false)
      form!.setFieldsValue({ verify: '' })
      if (error.msg === '验证码为空') {
        setShowCode(true)
      }
      if (showCode) {
        verification()
      }
    }
  }

  const verification = () => {
    verify({ verify_type: 'login' })
      .then(res => {
        setBase((base = res.data))
      })
      .catch(err => {})
  }

  document.onkeydown = e => {
    if (enter) {
      e.key === 'Enter' ? form.submit() : ''
    }
  }

  const toForgetPwd = () => {
    setEnter((enter = false))
    setLoginStatus('forget-pwd')
  }

  const toFirstLogin = () => {
    setEnter((enter = false))
    setLoginStatus('first-login')
  }

  useEffect(() => {
    agreement({
      token: undefined,
      user_id: undefined,
    })
      .then(res => {
        setAgreementOff(res?.data?.on_off === 1)
        // setAgreementOff(false)
      })
      .catch(() => {})
  }, [])

  useEffect(() => {
    const countdownInterval = setInterval(() => {
      setCountdown(prevCount => prevCount - 1)
    }, 1000)
    return () => {
      clearInterval(countdownInterval)
    }
  }, [countdown])

  return (
    <Direct>
      <Protocol visible={visible} consent={consent} protocolTab={protocolTab} />
      <Form
        form={form}
        onFinish={loginHandler}
        initialValues={{ agree: document.cookie.split(';').some(e => e === 'protocol') }}
      >
        <FormItemContainer>
          <Form.Item
            name="username"
            rules={[{ required: true, message: t('请输入邮箱/用户名') }]}
            getValueFromEvent={e => e.target.value.replace(/\s+/g, '')}
          >
            <Input
              prefix={<UserOutlined style={{ color: '#333333' }} />}
              placeholder={t('请输入邮箱/用户名')}
              maxLength={120}
            />
          </Form.Item>
        </FormItemContainer>
        <FormItemContainer>
          <Form.Item name={'password'} rules={[{ required: true, message: t('请输入密码') }]}>
            <Input.Password
              prefix={<LockOutlined style={{ color: '#333333' }} />}
              placeholder={t('请输入密码')}
              maxLength={120}
              onKeyDown={e => {
                e.key === 'Enter' ? form.submit() : ''
              }}
            />
          </Form.Item>
        </FormItemContainer>
        {showEmail && (
          <>
            <FormItemContainer>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <FormItem
                  name={'emailCode'}
                  rules={[{ required: true, message: t('请输入安全邮箱验证码') }]}
                  style={{ width: '70%', marginRight: '10px' }}
                >
                  <Input
                    prefix={<MailOutlined style={{ color: '#333333' }} />}
                    placeholder={t('请输入安全邮箱验证码')}
                    onKeyDown={e => {
                      e.key === 'Enter' ? form.submit() : ''
                    }}
                  />
                </FormItem>
                <div
                  style={{
                    width: '28%',
                    borderRadius: '4px',
                    overflow: 'hidden',
                    height: '36px',
                    background: 'rgba(66, 56, 201, 0.1)',
                    color: '#4238c9',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                  }}
                >
                  <Button
                    htmlType="button"
                    style={{
                      width: '100%',
                      height: '100%',
                      // cursor: 'pointer',
                      background: countdown > 0 ? '#E8E9ED' : 'rgba(66, 56, 201, 0.1)',
                      border: 'none',
                    }}
                    disabled={countdown > 0}
                    onClick={() => {
                      setCountdown(60)
                      emailVerify({
                        username: form.getFieldValue('username'),
                        // eslint-disable-next-line prettier/prettier
                        password: `${form.getFieldValue('username')} ${form.getFieldValue(
                          'password',
                        )}`,
                        verify: form.getFieldValue('verify'),
                      })
                        .then(() => {
                          // timer()
                        })
                        .catch(() => {})
                    }}
                  >
                    {/* {countdown > 0 ? `${secondsLeft}s后重新发送` : '发送'} */}
                    {countdown > 0 ? (
                      <span
                        style={{
                          color: '#999999',
                          background: '#E8E9ED',
                        }}
                      >
                        <span style={{ color: '#4238C9' }}>{countdown}S</span>
                        {t('重新发送')}
                      </span>
                    ) : (
                      <span
                        style={{
                          color: '#4238C9',
                        }}
                      >
                        {t('发送')}
                      </span>
                    )}
                  </Button>
                </div>
              </div>
            </FormItemContainer>
          </>
        )}
        {showCode && (
          <>
            <FormItemContainer>
              <div style={{ display: 'flex' }}>
                <Form.Item
                  name={'verify'}
                  rules={[{ required: true, message: t('请输入验证码') }]}
                  style={{ width: '78%', marginRight: '10px' }}
                >
                  <Input
                    prefix={<SafetyCertificateOutlined style={{ color: '#333333' }} />}
                    placeholder={t('请输入验证码')}
                  />
                </Form.Item>
                <div
                  style={{ width: '22%', borderRadius: '4px', overflow: 'hidden', height: '32px' }}
                >
                  <Image
                    height={'32px'}
                    src={`data:image/png;base64,${base?.base64}`}
                    preview={false}
                    onClick={() => verification()}
                  />
                </div>
              </div>
            </FormItemContainer>
          </>
        )}
        <LoginPwd>
          {firstLoginStatus ? (
            <div>
              {t('首次登录，请重置密码再登录')}
              <Typography.Link onClick={() => toFirstLogin()} className="changePwd">
                {t('重置密码')}
              </Typography.Link>
            </div>
          ) : (
            <Typography.Link onClick={() => toForgetPwd()} className="retrieve">
              {t('忘记密码?')}
            </Typography.Link>
          )}
        </LoginPwd>
        <LoginPwd start>
          {pwdExpired && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexWrap: 'nowrap',
                marginTop: 16,
              }}
            >
              <span> {t('您的密码已过期，请修改密码再登录')}</span>
              <span onClick={() => toFirstLogin()} className="changePwd">
                {t('修改密码')}
              </span>
            </div>
          )}
        </LoginPwd>
        <LoginBtnContainer>
          <BlockButton
            block
            className="loginBtn"
            loading={loginLoading}
            type={'primary'}
            onClick={form.submit}
          >
            {t('登录')}
          </BlockButton>
        </LoginBtnContainer>
        {agreementOff && (
          <AgreementDiv>
            <Form.Item
              name={'agree'}
              style={{ marginTop: 40 }}
              className={protocol && 'shake'}
              valuePropName="checked"
            >
              <Checkbox>
                <span
                  style={{
                    color: '#333333',
                  }}
                >
                  {t('我已阅读并同意')}

                  <span
                    className="protocol"
                    onClick={e => {
                      e.preventDefault()
                      setVisible({ visibleShow: true, data: null })
                      setProtocolTab('privacy')
                    }}
                  >
                    {t('隐私政策')}
                  </span>
                  {t('和')}
                  <span
                    className="protocol"
                    onClick={e => {
                      e.preventDefault()
                      setVisible({ visibleShow: true, data: null })
                      setProtocolTab('service')
                    }}
                  >
                    {t('服务协议')}
                  </span>
                </span>
              </Checkbox>
            </Form.Item>
          </AgreementDiv>
        )}
      </Form>
    </Direct>
  )
}

const LoginPwd = styled.div`
  display: flex;
  justify-content: ${props =>
    props.firstLoginStatus ? 'space-between' : props.start ? 'flex-start' : 'flex-end'};
  align-items: flex-end;
  .changePwd {
    color: #807ddb;
    margin-left: 6px;
    &:hover {
      color: #807ddb;
      cursor: pointer;
    }
  }
  .retrieve {
    color: #666666;
    &:hover {
      color: #807ddb;
    }
  }
`

const LoginBtnContainer = styled.div`
  margin-top: 5px;
  position: relative;
  border: 1px solid #4238c9;
  border-radius: 6px;
  background: #4238c9;
  margin-top: 20px;
  &::after {
    background: linear-gradient(320deg, #675fd3 0%, #4238c9 100%);
  }
  &:hover {
    background: linear-gradient(320deg, #675fd3 0%, #4238c9 100%);
  }
  .ant-btn-primary {
    background: #4238c9;
  }
`

const AgreementDiv = styled.div`
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #4238c9;
    border-color: #4238c9;
  }
  .ant-checkbox-checked::after {
    border-color: #4238c9;
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #4238c9;
  }

  input#agree {
    border-color: #4238c9;
  }
`

const Direct = styled.div`
  .ant-input-affix-wrapper,
  .ant-input {
    border-color: #d9d9d9;
    &:hover {
      border-color: #4238c9;
    }
  }
  input:-webkit-autofill,
  textarea:-webkit-autofill,
  select:-webkit-autofill {
    background-image: none;
    transition: background-color 50000s ease-in-out 0s;
  }
  input {
    //background-color: transparent;
  }
  .ant-input-affix-wrapper {
    height: 36px;
  }
  .protocol {
    cursor: pointer;
    color: #4238c9;
    &:hover {
      color: #807ddb;
    }
  }
  .shake {
    transform-style: preserve-3d;
    animation: shake 800ms ease-in-out;
  }
  @keyframes shake {
    10%,
    90% {
      transform: rotate(2deg);
    }
    20%,
    80% {
      transform: rotate(-2deg);
    }
    30%,
    70% {
      transform: rotate(2deg);
    }
    40%,
    60% {
      transform: rotate(-2deg);
    }
    50% {
      transform: rotate(2deg);
    }
  }
`

export const BlockButton = styled(Button)`
  height: 38px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  &::after {
    background: linear-gradient(320deg, #4238c9 0%, #675fd3 100%);
  }
  &:hover {
    background: linear-gradient(320deg, #675fd3 0%, #4238c9 100%);
    border: none;
  }
`
